import { Provider } from "react-redux";

import { Router } from "react-router-dom";
import FullStory from "services/Fullstory";
import { ConfirmProvider } from "containers/Confirm/Confirm.context";

import RouteAuthorization from "core/RouteAuthorization";
import RouteDispatcher from "core/RouteDispatcher";

import useVersionCheck from "./hooks/useVersionCheck";
import { ModalContextProvider } from "./contexts/ModalContext";

import appConfig from "./config/appConfig";
import rootSaga from "./sagas/rootSaga";
import store from "./store/configureStore";
import historyInstance from "./utils/history";

import GlobalStyles from "./components/GlobalStyles/GlobalStyles.component";

import Routes from "./Routes";
import AppErrorBoundary from "./App.ErrorBoundary";
import AppGlobalStyles from "./App.GlobalStyles";
import routesMapped from "./routesMapped";
import routesObject from "./routesObject";
import MainLayout from "./MainLayout";


routesMapped.init(routesObject);
store.runSaga(rootSaga);
appConfig();
FullStory.init();

export default function App() {

  useVersionCheck({ disabled: import.meta.env.DEV });

  return (
    <AppErrorBoundary>
      <AppGlobalStyles />
      <GlobalStyles />
      <Provider store={store}>
        {/* @ts-ignore - React Router v5 type compatibility issue with React 17+ */}
        <Router history={historyInstance}>
          <ConfirmProvider>
            <RouteDispatcher>
              <ModalContextProvider>
                <MainLayout>
                  <RouteAuthorization>
                    <Routes />
                  </RouteAuthorization>
                </MainLayout>
              </ModalContextProvider>
            </RouteDispatcher>
          </ConfirmProvider>
        </Router>
      </Provider>
    </AppErrorBoundary>
  );
}
